export type LanguageCode = string;
export type SupportedLanguage = LanguageCode;
export const SUPPORTED_UI_LANGUAGES = ["en", "tr", "ar"] as const;
export type SupportedUiLanguage = (typeof SUPPORTED_UI_LANGUAGES)[number];
export type SupportedLevel = "a1" | "a2" | "b1" | "b2";

export type DomainKey =
  | "social_interaction"
  | "daily_life"
  | "services_public_interactions"
  | "communication_repair_problem_solving";

export interface DomainOption {
  key: DomainKey;
}

export const SOURCE_LANGUAGE: SupportedLanguage = "en";

export const DOMAIN_OPTIONS: DomainOption[] = [
  { key: "social_interaction" },
  { key: "daily_life" },
  { key: "services_public_interactions" },
  { key: "communication_repair_problem_solving" },
];

export const LEVEL_OPTIONS: Array<{ key: SupportedLevel }> = [
  { key: "a1" },
  { key: "a2" },
  { key: "b1" },
  { key: "b2" },
];
